import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/button';
import { useDriverTheme } from '@/hooks/useDriverTheme';
import { usePermissionsGate } from '@/hooks/usePermissionsGate';
import { useLanguage } from '@/hooks/useLanguage';
import { MapPin } from 'lucide-react';

/**
 * Non-dismissible bottom rationale shown after the user grants foreground
 * location, before we route them to the system "Allow all the time" page.
 */
export default function BackgroundLocationRationaleSheet() {
  const { locationStep, confirmBackgroundRationale } = usePermissionsGate();
  const { tokens, isDark } = useDriverTheme();
  const { t } = useLanguage();
  const open = locationStep === 'await-rationale';

  return (
    <DialogPrimitive.Root open={open}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[80] bg-black/60 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          onPointerDownOutside={(e) => e.preventDefault()}
          onEscapeKeyDown={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
          className="fixed inset-x-0 bottom-0 z-[81] rounded-t-2xl shadow-xl data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom"
          style={{
            background: isDark ? '#241c17' : '#ffffff',
            paddingBottom: 'env(safe-area-inset-bottom)',
          }}
        >
          <div className="px-5 pt-5 pb-4">
            <div className="flex items-center gap-3 mb-3">
              <div
                className="flex h-10 w-10 items-center justify-center rounded-full"
                style={{ background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)' }}
              >
                <MapPin className="h-5 w-5" style={{ color: tokens.textPrimary }} />
              </div>
              <DialogPrimitive.Title className="text-base font-bold" style={{ color: tokens.textPrimary }}>
                {t('bg_location_needed')}
              </DialogPrimitive.Title>
            </div>
            <DialogPrimitive.Description className="text-sm leading-relaxed mb-5" style={{ color: tokens.textSecondary }}>
              {t('bg_location_body')}
            </DialogPrimitive.Description>
            <Button
              onClick={() => { void confirmBackgroundRationale(); }}
              className="w-full h-11 rounded-xl text-base font-bold bg-orange-500 hover:bg-orange-600 text-white"
            >
              {t('ok')}
            </Button>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
